import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { Avatar, alpha } from '@mui/material';
import { MODULE_ACCENT_COLORS } from '../../theme/module-colors';

interface CompanyLogoAvatarProps {
  /** Signed URL of the company logo; null shows the company icon. */
  logoUrl: string | null;
  size: number;
}

const accent = MODULE_ACCENT_COLORS.teamConsultants.main;

/**
 * The name is always written next to the avatar, so the logo is decorative.
 * MUI falls back to the icon child when the image fails to load (expired URL).
 */
export function CompanyLogoAvatar({ logoUrl, size }: CompanyLogoAvatarProps) {
  return (
    <Avatar
      variant="rounded"
      src={logoUrl ?? undefined}
      alt=""
      aria-hidden="true"
      data-testid="company-logo-avatar"
      data-has-logo={logoUrl ? 'true' : 'false'}
      slotProps={{ img: { style: { objectFit: 'contain', padding: 3 } } }}
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        flexShrink: 0,
        color: accent,
        bgcolor: logoUrl ? 'common.white' : alpha(accent, 0.1),
        border: logoUrl ? '1px solid' : 'none',
        borderColor: 'divider',
        '& .MuiSvgIcon-root': { fontSize: size * 0.5 },
      }}
    >
      <BusinessOutlinedIcon />
    </Avatar>
  );
}
